import script from "./CurrentMonthIncinerated.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentMonthIncinerated.vue?vue&type=script&setup=true&lang=js"

import "./CurrentMonthIncinerated.vue?vue&type=style&index=0&id=143b8808&lang=css"

const __exports__ = script;

export default __exports__